import { render, staticRenderFns } from "./Relations.vue?vue&type=template&id=22092229&scoped=true&"
import script from "./Relations.vue?vue&type=script&lang=js&"
export * from "./Relations.vue?vue&type=script&lang=js&"
import style0 from "./Relations.vue?vue&type=style&index=0&id=22092229&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22092229",
  null
  
)

export default component.exports